import React, { useContext, useEffect, useState } from 'react'
import { CButton, CCard } from '@coreui/react'

import moment from 'moment'
import { checkPermissions, getThumbnail, raiseToast } from '../../utils/helper'
import { GlobalContext } from '../../context/GlobalState'
// import SearchTable from 'src/components/searchTable'
import useAxios from 'axios-hooks'
import { CUSTOM_FORM_API } from '../../utils/urls'
import { AppContext } from '../../context/app'
import { isEmpty } from 'lodash'
import InfiniteScroll from 'react-infinite-scroll-component'
import AssetFilter from '../AssetManager/AssetFilter'
import EditIcon from '../../../assets/edit-svg-black.svg'
import EyeIcon from '../../../assets/eye-black-icon.svg'
import AddIcon from '../../../assets/addnew-icon2.svg'
import FormListCard from './formListCard'
import FormNameModal from './formNameModal'
import FormModal from './formModal'
import FormPreview from './formPreview'
import { PERMISSIONS } from '../../utils/permissions'

const CustomForms = () => {
  const [formData, setFormData] = useState([])
  const [searchText, setSearchText] = useState('')
  const [nameModal, setNameModal] = useState(false)
  const [formModal, setFormModal] = useState(false)
  const [formName, setFormName] = useState('')
  const [selectedFormData, setSelectedFormData] = useState({})
  const { userSessionObj } = useContext(GlobalContext)
  const { setLoader, accountObj } = useContext(AppContext)
  const [page, setPage] = useState(1)

  const [previewForm, setPreviewForm] = useState({})
  const [basicInfo, setBasicInfo] = useState([])

  const createAllowed = checkPermissions(
    userSessionObj.session_data.permissions,
    PERMISSIONS.CUSTOM_FORMS.CREATE,
  )
  const updateAllowed = checkPermissions(
    userSessionObj.session_data.permissions,
    PERMISSIONS.CUSTOM_FORMS.UPDATE,
  )

  let entityNameObj = {
    ARTIST_DETAIL: 'Artist Detail page',
    ARTIST_LIST: 'Artist listing page',
    CATEGORY: 'Category landing page',
    PAGES: 'Custom Pages',
    CONTENT_DETAIL: 'Content Detail Page',
    CONTENT_DETAIL_PLAYER: 'Content Detail Page & Player',
    PLAYER: 'Only Player',
    LOGIN: 'Log-in page',
    REGISTER: 'Register Page',
    HOME: 'Home Page',
    IPTV: 'IPTV Channel',
    ALL_IPTV: 'All IPTV Channels',
    PRICING: 'Pricing Page',
    VENUE_DETAIL: 'Venue Detail page',
    VENUE_LIST: 'Venue listing page',
  }

  const [{ data: formList, loading: formListLoading }, formListCall] = useAxios(
    {
      url: CUSTOM_FORM_API,
      method: 'get',
    },
    { manual: true },
  )

  const [{ data: createForm, loading: createFormLoading }, createFormCall] = useAxios(
    {
      url: CUSTOM_FORM_API,
      method: 'post',
    },
    { manual: true },
  )

  const [{ data: updateForm, loading: updateFormLoading }, updateFormCall] = useAxios(
    {
      url: CUSTOM_FORM_API,
      method: 'put',
    },
    { manual: true },
  )

  useEffect(() => {
    formListCall()
  }, [])

  useEffect(() => {
    setLoader(formListLoading || createFormLoading || updateFormLoading)
  }, [formListLoading, createFormLoading, updateFormLoading])

  useEffect(() => {
    if (formList && formList.success) {
      setFormData(formList.data)
    }
  }, [formList])

  useEffect(async () => {
    if (createForm && createForm.success) {
      await formListCall({
        params: { search_text: searchText },
      })
      setFormModal(false)
      setFormName('')
      raiseToast('success', 'Form Created Successfully!')
    }
  }, [createForm])

  useEffect(async () => {
    if (updateForm && updateForm.success) {
      await formListCall({
        params: { search_text: searchText },
      })
      setFormModal(false)
      raiseToast('success', 'Form Updated Successfully!')
      setSelectedFormData({})
    }
  }, [updateForm])

  const handleSearch = (value) => {
    setSearchText(value)
  }

  const handleNextPage = () => {
    formListCall({
      params: { search_text: searchText },
    })
  }

  const handleEdit = (info) => {
    if (updateAllowed) {
      setSelectedFormData(info)
      setFormModal(true)
    } else {
      raiseToast('error', "You don't have enough permission")
    }
  }
  const handleStatus = async (status, id) => {
    if (updateAllowed) {
      await updateFormCall({
        params: {
          form_id: id,
        },
        data: { status: status },
      })
    } else {
      raiseToast('error', "You don't have enough permission")
    }
  }

  const handleCustomForm = async (payload) => {
    isEmpty(selectedFormData)
      ? await createFormCall({ data: payload })
      : await updateFormCall({
          params: {
            form_id: selectedFormData?._id,
          },
          data: payload,
        })
  }

  useEffect(() => {
    setBasicInfo([
      {
        property: 'Form Name:',
        value: previewForm?.name,
      },
      {
        property: 'Number of Fields:',
        value: previewForm?.fields?.data?.length,
      },
      {
        property: 'Placement:',
        value: entityNameObj[previewForm?.entities?.type],
      },
      {
        property: 'Linked to Content:',
        value:
          previewForm?.entities?.type === 'CONTENT_DETAIL' ||
          previewForm?.entities?.type === 'CONTENT_DETAIL_PLAYER' ||
          previewForm?.entities?.type === 'PLAYER'
            ? 'Yes'
            : 'No',
      },
      {
        property: 'Default Behaviour :',
        value: previewForm?.is_minimised ? 'Minimize' : 'Open',
      },
      {
        property: 'Created on:',
        value: moment(previewForm?.created_date).format('DD MMM YYYY'),
      },
      {
        property: 'Created by:',
        value: previewForm?.created_by,
      },
      {
        property: 'Last Edited on:',
        value: moment(previewForm?.modified_date).format('DD MMM YYYY'),
      },
      {
        property: 'Last Edited by:',
        value: previewForm?.last_modified_by,
      },
    ])
  }, [previewForm])

  const handleCreateForm = () => {
    if (createAllowed) {
      setFormName('')
      setNameModal(true)
    } else {
      raiseToast('error', "You don't have enough permission")
    }
  }

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mt-4">
        <div>
          <h4>Custom Forms</h4>
          <p>Following are the Custom Forms which are already in your store.</p>
        </div>
        <CButton
          className="text-white px-3"
          onClick={handleCreateForm}
          disabled={!createAllowed}
          style={{ pointerEvents: 'auto', fontSize: '18px', background: '#20211c' }}
        >
          + Add New Form
        </CButton>
      </div>
      <div
        className="d-flex justify-content-center align-items-center "
        style={{
          padding: '1.42vw 0vw 0',
          margin: '0 auto 3vh',
          width: '100%',
        }}
      >
        <div>
          <AssetFilter
            onSearch={handleSearch}
            dropdownHeight={'300px'}
            disableFilter={true}
            searchStyle={{ background: '#fff' }}
          />
        </div>
      </div>
      <CCard>
        {!isEmpty(previewForm) && (
          <FormPreview
            onClose={() => setPreviewForm({})}
            cardImage={getThumbnail(
              userSessionObj.session_data.cf_domain_name,
              previewForm?.thumbnail?.s3_key,
            )}
            headline="Form Preview"
            subHeadline={`Detail information about '${previewForm?.name}' form`}
            basicInfo={basicInfo}
          />
        )}
        <div>
          <div id="scrollableDiv" className="asset-manager-card position-relative">
            <InfiniteScroll
              dataLength={formData.length} //This is important field to render the next data
              next={handleNextPage}
              hasMore={formList && formList.total > page * 20}
              style={{ overflowX: 'hidden' }}
              loader={<p>Loading...</p>}
              className="scrollbar-class"
              height={`65vh`}
              scrollableTarget="scrollableDiv"
            >
              <div
                className="d-flex px-2 justify-content-center align-items-center w-100 bg-black text-white position-absolute"
                style={{
                  fontSize: 'max(0.63vw,10px)',
                  // gap: '0 2.2%',
                  paddingTop: '2px',
                  paddingBottom: '2px ',
                  top: '0',
                  zIndex: '10',
                }}
              >
                <div style={{ marginBlockEnd: '0', width: '10%' }} className="text-center mx-2" />
                <div style={{ width: '90%' }} className="d-flex align-items-center">
                  <div style={{ marginBlockEnd: '0', width: '42%' }}>Form Name</div>
                  <div style={{ marginBlockEnd: '0', width: '24%' }}>Created on</div>
                  <div style={{ marginBlockEnd: '0', width: '17%' }}>Placement</div>
                  <div style={{ marginBlockEnd: '0', width: '12%', textAlign: 'center' }}>
                    Status
                  </div>
                  <div style={{ width: '5%' }}></div>
                </div>
              </div>

              <div
                className="d-flex flex-wrap"
                style={{
                  gap: '1.2vw 0',
                  padding: '30px 8px 20px 8px',
                }}
              >
                {!isEmpty(formData) ? (
                  formData
                    .filter((data) =>
                      searchText.trim().length
                        ? data.name.toLowerCase().includes(searchText.toLowerCase())
                        : true,
                    )
                    .map((info, index) => {
                      return (
                        <FormListCard
                          cardImage={getThumbnail(
                            userSessionObj.session_data.cf_domain_name,
                            info?.thumbnail?.s3_key,
                          )}
                          textData={[
                            {
                              name: info?.name,
                              styles: {
                                overflow: 'hidden',
                                fontWeight: '600',
                                fontSize: '14px',
                                width: '42%',
                              },
                            },
                            {
                              name: moment(info?.created_date).format('DD MMM YYYY'),
                              styles: { width: '24%' },
                            },
                            {
                              name: entityNameObj[info?.entities?.type],
                              styles: { width: '17%' },
                            },
                          ]}
                          key={index}
                          status={info?.status}
                          statusCallback={(value) => {
                            handleStatus(value, info._id)
                          }}
                          actionButtonOptions={[
                            {
                              name: 'Preview',
                              btnFunction: () => {
                                setPreviewForm(info)
                              },
                              logo: (
                                <div className="flex mr-1">
                                  <img style={{ width: '10px' }} src={EyeIcon} />
                                </div>
                              ),
                            },
                            {
                              name: 'Edit',
                              btnFunction: () => handleEdit(info),
                              logo: (
                                <div className="flex mr-1">
                                  <img style={{ width: '10px' }} src={EditIcon} />
                                </div>
                              ),
                            },
                          ]}
                          actionButtonWidth="5%"
                        />
                      )
                    })
                ) : (
                  <p>No form data available</p>
                )}

                {createAllowed && (
                  <div
                    style={{
                      width: '100%',
                      aspectRatio: '1506/71',
                      boxShadow: ' 3px 3px 6px 0 rgba(0, 0, 0, 0.16)',
                      display: 'flex',
                      background: '#ececec',
                      fontSize: '0.833vw',
                      fontWeight: 550,
                    }}
                    className={`rounded-1 cursor-pointer d-flex flex-col justify-content-center align-items-center`}
                    onClick={() => {
                      setFormName('')
                      setNameModal(true)
                    }}
                  >
                    <img
                      src={AddIcon}
                      alt="AddIcon"
                      className=""
                      style={{ width: '1.25vw', height: '1.25vw' }}
                    />
                    <span className="">Add new Form</span>
                  </div>
                )}
              </div>
            </InfiniteScroll>
          </div>
        </div>
      </CCard>
      {nameModal && (
        <FormNameModal
          onCancel={() => {
            setFormName('')
            setNameModal(false)
          }}
          onSave={(value) => {
            setFormName(value)
            setNameModal(false)
            setFormModal(true)
          }}
        />
      )}
      {formModal && (
        <FormModal
          data={selectedFormData}
          formName={formName}
          onSave={(payload) => {
            handleCustomForm(payload)
          }}
          onCancel={() => {
            setSelectedFormData({})
            setFormName('')
            setFormModal(false)
          }}
        />
      )}
    </>
  )
}

export default CustomForms
